import React, { useContext, useEffect, useState } from 'react';
import { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';
import { planes } from '../../data/cotizadorCrData';
import { frecuenciaPagos } from '../../data/mochaData';
import http from '../../services/http';
import { endPoints, monedas } from '../../utils/constanst';
import DivRow from '../controls/DivRow';
import Input from '../controls/Input';
import InputSelect from '../controls/InputSelect';
import SwitchButton from '../controls/SwitchButton';
import ReactTooltip from 'react-tooltip';
import Select from 'react-select';
import CustomSelect from '../controls/CustomSelect';

const Step1 = () => {



    const { poliza, tarificacion, catalogos, setPoliza, setTarificacion, setCatalogos, polizaChangeHandler, tarificacionChangeHandler, init } = useContext(CotizadorCRDataContext);

    useEffect(() => {

        if (init) {
            cargarCatalogos(poliza.planId);

        }
    }, [init]);



    const cargarCatalogos = async (planId) => {
        const [rastreoSatelital, marcas, deducibles, coberturas, usos, planesUsr] = await Promise.all([
            http(endPoints.rastreosatelital).get(),
            http(endPoints.brands(planId)).get(),
            http(endPoints.deductibles(planId)).get(),
            http(endPoints.coverages(planId)).get(),
            http(endPoints.vhUses).get(),
            http(endPoints.configPlans(1)).get()
        ]);
        setCatalogos({ rastreoSatelital, marcas, deducibles, coberturas, usos });
        setPoliza({ planesConfig: planesUsr.filter(x => x.id == planes.planDolares || x.id == planes.planColones) });
    }

    useEffect(() => {
        Promise.all([
            http(endPoints.brands(poliza.planId)).get(),
            http(endPoints.deductibles(poliza.planId)).get(),
            http(endPoints.coverages(poliza.planId)).get()])
            .then(r => {
                setCatalogos({
                    marcas: r[0],
                    deducibles: r[1],
                    coberturas: r[2]
                });

            });
    }, [poliza.planId])

    useEffect(() => {
        if (poliza.planesConfig != null)
            setPoliza({ ...poliza, planConfig: poliza.planesConfig.find(x => poliza.planId) });

    }, [poliza.planId])

    useEffect(() => {
        if (tarificacion.marc != 0 && tarificacion.mode != 0 && tarificacion.anio != 0) {
            http(endPoints.datasheet(poliza.planId, tarificacion.marc, tarificacion.mode, tarificacion.anio)).get()
                .then(r => setTarificacion(r));
        }
    }, [tarificacion.anio]);


    const frecuenciaHandler = event => {
        let v = event.target.value;
        setPoliza({ [event.target.name]: v, frecuenciaPagos: v });
    }

    const monedaHandler = (value) => {
        setPoliza({
            moneda: value ? monedas.dolares : monedas.colones,
            planId: value ? planes.planDolares : planes.planColones
        });
    }

    const marcaHandler = (event) => {
        setTarificacion({ [event.target.name]: event.target.value, mode: -1 });
        http(endPoints.models(poliza.planId, event.target.value)).get()
            .then(data => { setCatalogos({ modelos: data }); })
    }

    const modeloHandler = (event) => {
        tarificacionChangeHandler(event);
        http(endPoints.lastYear(poliza.planId, tarificacion.marc, event.target.value)).get()
            .then(data => { setCatalogos({ anios: data }); setTarificacion({ anio: 0 }); })

    }

    const valorHandler = (event) => {
        tarificacionChangeHandler(event);
        let value = event.target.value;
        let dedu = getDeducible(value)
        setTarificacion({ dedu: dedu });
    }

    const getDeducible = () => {
        let v = tarificacion.valn ?? 0;

        if (poliza.planId == planes.planDolares) {
            if (v <= 30000)
                return catalogos.deducibles.filter(x => x.value == '16' || x.value == '6');
            if (v > 30000 && v <= 50000)
                return catalogos.deducibles.filter(x => x.value == '16' || x.value == '6');
            if (v > 50000 && v <= 60000)
                return catalogos.deducibles.filter(x => x.value == '16' || x.value == '6');
            if (v > 60000)
                return catalogos.deducibles.filter(x => x.value == '16' || x.value == '6');
        }
        else {
            if (v <= 18842097)
                return catalogos.deducibles.filter(x => x.value == '16' || x.value == '6');
            if (v > 18842097 && v <= 31403495)
                return catalogos.deducibles.filter(x => x.value == '16' || x.value == '6');
            if (v > 31403495 && v <= 37684194)
                return catalogos.deducibles.filter(x => x.value == '16' || x.value == '6');
            if (v > 37684194)
                return catalogos.deducibles.filter(x => x.value == '16' || x.value == '6');
        }
        return [];
    }




    return (
        <div className="reponsive">

            <div className="reponsive-width-6">
                <div className="box-pl5-pr5">
                    <SwitchButton data-tip="hello world" label="Moneda de la póliza" si="Dólares" no="Colones" value={poliza.moneda === monedas.dolares} onClick={monedaHandler} />
                    <CustomSelect label='Frecuencia de pago' field='ncuotas' value={poliza.ncuotas} catalog={frecuenciaPagos} onChange={frecuenciaHandler} />
                    {/* <InputSelect label='Marca' field='marc' containBlank={true} value={tarificacion.marc} dataProvider={catalogos.marcas} onChange={marcaHandler} /> */}
                    <CustomSelect id="marca" label='Marca' field='marc' containBlank={true} value={tarificacion.marc} catalog={catalogos.marcas} onChange={marcaHandler} />

                    {/* <InputSelect label='Modelo' field='mode' containBlank={true} value={tarificacion.mode} dataProvider={catalogos.modelos} onChange={modeloHandler} /> */}
                    <CustomSelect id='modelo' label='Modelo' field='mode' containBlank={true} value={tarificacion.mode} catalog={catalogos.modelos} onChange={modeloHandler} />
                    <CustomSelect label='Año' field='anio' containBlank={true} value={tarificacion.anio} catalog={catalogos.anios} onChange={tarificacionChangeHandler} />
                </div>

            </div>
            <div className="reponsive-width-6">
                <div className="box-pl5-pr5">
                    <CustomSelect label='Uso del Vehículo' field='usoo' value={tarificacion.usoo} catalog={catalogos.usos} onChange={tarificacionChangeHandler} />
                    <Input type='number' label='Valor del Vehículo' field='valn' value={tarificacion.valn} onChange={tarificacionChangeHandler} info="Consiste en el valor de mercado de su Vehículo, excluyendo equipos especiales" />
                    <CustomSelect label='Deducibles' containBlank={true} field='dedu' value={tarificacion.dedu} catalog={getDeducible()} onChange={tarificacionChangeHandler} info="Es la cantidad de dinero que debe pagar a Seguros LAFISE en caso de sufrir un accidente o una pérdida." />
                    <SwitchButton label="Vehículo" si="Nuevo" no="Usado" value={tarificacion.auNuevo === 1} onClick={value => setTarificacion({ auNuevo: value ? 1 : 0 })} />
                    <CustomSelect label='Dispositivo' field='rsat' value={tarificacion.rsat} catalog={catalogos.rastreoSatelital} onChange={tarificacionChangeHandler} />
                </div>
            </div>
            <ReactTooltip className='tipstyle' multiline={true} />
        </div>
    );
}

export default Step1;
